"use client";
import style from "@/styles/Brochure.module.scss";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Image from "next/image";
import img from "../../public/images/brochure.png";
import CloudflareCaptcha from "@/Components/CloudflareCaptcha";

import FloatingField from "@/Ui_Elements/FloatingField/FloatingField";
import { getValidationSchema } from "@/lib/validationSchemas.js";
import { CommonSubmitForm } from "@/lib/CommonSubmitForm";
import { yupResolver } from "@hookform/resolvers/yup";

const Brochure = () => {
  const validationSchema = getValidationSchema(5);
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    setValue,
    clearErrors,
    reset,
    setError, // <-- added
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  const [isValidNum, setIsValidNum] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaKey, setCaptchaKey] = useState(0);

  // Cloudflare captcha callback
  const handleVerify = (token) => {
    setCaptchaToken(token || null);

    if (token) {
      setValue("captcha", token, {
        shouldValidate: true,
        shouldDirty: true,
      });
      clearErrors("captcha");
    } else {
      setValue("captcha", null);
    }
  };

  const resetCaptcha = () => {
    setCaptchaToken(null);
    clearErrors("captcha");

    // 🔥 Force remount Turnstile
    setCaptchaKey((k) => k + 1);
  };

  // Phone input change callback (from your FloatingField / intl input)
  const onPhoneChange = (isValid, rawValue) => {
    const containsOnlyNumbers = /^\d+$/.test(rawValue);

    if (containsOnlyNumbers || !rawValue) {
      setIsValidNum(isValid);
      setPhoneNumber(rawValue);
      setValue("mobile", rawValue, { shouldValidate: true });
    }
  };

  // Final submit handler
  const onSubmit = async (data, e) => {
    const isValidForm = await trigger();
    // check captcha
    if (!captchaToken) {
      setError("captcha", { type: "manual", message: "Captcha verification failed" });
      return;
    }
    if (isValidForm && isValidNum && captchaToken) {
      const res = await CommonSubmitForm(5, data);
      if (res.success) {
        reset();
        setPhoneNumber("");
        setValue("captcha", null);
        resetCaptcha();
        const pdfUrl = "/assets/pdf/Vidyalaya_LMS_Brochure.pdf";
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "Vidyalaya LMS Brochure.pdf";
        link.click();
      }
    }
  };

  return (
    <section className={`${style["brochureformmaindiv"]}`}>
      <div className="container">
        <div className={`${style["contactformbody"]}`}>
          <div className={`${style["left"]}`}>
            <div className={style.Orangespandiv}>
              <span className={style.Orangespan}>Brochure</span>
            </div>
            <h2 className={`${style["title"]} commonsectiontitle`}> Easily & Quickly Downloadable Information</h2>
            <p className={`${style["description"]}`}>Want to know more about Vidyalaya LMS Software, our high quality , informative brochures are just a click away.</p>
            <form id="brochure-form" className={`${style["formmain"]} brochure-form`} onSubmit={handleSubmit(onSubmit)} autoComplete="on">
              <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                <FloatingField
                  id="name_brochure"
                  type="text"
                  label="Your Name"
                  placeholder="Enter your name"
                  name="name"
                  register={register}
                  error={errors.name}
                  setValue={setValue}
                  isFloatedLabel={false}
                />
              </div>
              <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                <FloatingField
                  id="mobile_brochure"
                  type="intl"
                  label="Phone no."
                  placeholder="Phone no."
                  name="mobile"
                  register={register}
                  phoneNumber={phoneNumber}
                  isValidNum={isValidNum}
                  onPhoneNumberChange={onPhoneChange}
                  error={errors.mobile}
                  setValue={setValue}
                  isFloatedLabel={false}
                />
              </div>
              <div className={`${style["inputgroup"]} inputgroup ${style["w-100"]}`}>
                <FloatingField
                  id="email_brochure"
                  type="email"
                  label="Your Email"
                  placeholder="Enter your email"
                  name="email"
                  register={register}
                  error={errors.email}
                  setValue={setValue}
                  isFloatedLabel={false}
                />
              </div>

              <div className={`${style["inputgroup"]} inputgroup ${style["w-50"]}`}>
                <div className={`${style["recaptcha"]} c-recaptcha`}>
                  <CloudflareCaptcha onVerify={handleVerify} key={captchaKey} />
                  {errors.captcha && <div className={`${style["error"]} captcha-error`}>{errors.captcha.message}</div>}
                  <input
                    type="hidden"
                    {...register("captcha", {
                      required: "Captcha verification failed",
                    })}
                  />
                </div>
              </div>

              {/* Add other form fields here */}
              <div className={`${style["formbottompart"]}`}>
                <button className={`${style["buttonsubmit"]} commonformbtn`} type="submit">
                  Download Brochure
                </button>
              </div>
            </form>
          </div>
          <div className={`${style["right"]} ${style["bgcard"]}  ${style["bgcardpattrent"]} `}>
            <div className={`${style["img-div"]}`}>
              <Image src={img} alt={"Brochure"} width={0} height={0} className={`${style["main-img"]}`} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Brochure;
